"use client";

import { useState } from "react";
import { transcript, runs, featuredSessionId } from "./checkrideV6DemoData";

const STEP = 14;

/**
 * The whole conversation, in the order it happened. No excerpting beyond "show more",
 * because an exam read in fragments is an exam you can flatter.
 */
export default function V6Transcript() {
  const [shown, setShown] = useState(STEP);
  const run = runs.find((r) => r.sessionId === featuredSessionId)!;
  const rows = transcript.slice(0, shown);

  return (
    <section id="conversation" className="py-24 md:py-32 px-6 bg-ground-alt border-t border-hairline/60">
      <div className="max-w-3xl mx-auto">
        <span className="text-[11px] font-semibold tracking-wider uppercase text-accent">
          The exam itself
        </span>
        <h2 className="mt-3 text-3xl md:text-4xl font-bold tracking-[-0.02em] text-ink">
          Every word, in the order it was said
        </h2>
        <p className="mt-4 text-ink-soft leading-relaxed">
          This is the full record of one candidate&rsquo;s oral — {run.questions} questions
          over {run.turns} exchanges. He is a careful candidate who pushes back when a
          question could be read two ways, which is the most interesting thing an examiner
          has to handle. Nothing is trimmed for effect.
        </p>

        <div className="mt-10 space-y-5">
          {rows.map((t, i) => (
            <div key={i} className={t.who === "examiner" ? "" : "pl-6 md:pl-12"}>
              <div className={`text-[10px] font-bold uppercase tracking-wider mb-1.5 ${
                t.who === "examiner" ? "text-accent" : "text-ink-faint"
              }`}>
                {t.who === "examiner" ? "Examiner" : "Candidate"}
              </div>
              <div className={`rounded-2xl px-5 py-4 text-[15px] leading-relaxed whitespace-pre-wrap ${
                t.who === "examiner"
                  ? "bg-white border border-hairline text-ink lift"
                  : "bg-ground-alt text-ink-soft"
              }`}>
                {t.said}
              </div>
            </div>
          ))}
        </div>

        {shown < transcript.length ? (
          <div className="mt-10 text-center">
            <button
              onClick={() => setShown((s) => Math.min(s + STEP, transcript.length))}
              className="pill pill-quiet transition-colors"
            >
              Show more &mdash; {transcript.length - shown} left
            </button>
            <button
              onClick={() => setShown(transcript.length)}
              className="ml-3 px-7 py-3 text-ink-faint hover:text-ink-soft text-sm transition-colors"
            >
              Show the whole exam
            </button>
          </div>
        ) : (
          <p className="mt-10 text-center text-sm text-ink-faint">
            That is the complete exam &mdash; all {transcript.length} utterances.
          </p>
        )}
      </div>
    </section>
  );
}
